const formatMoney = (number, thousands = ' ', currency = 'kr') => {
  if (!number) return `0 ${currency}`;
  return `${number
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, thousands)} ${currency}`;
};

export default formatMoney;
